<template>
  <portal :target-el="portalTarget">
    <div :id="id" :class="classNames.base" ref="rootElement">
      <div
        data-a11y-dialog-hide
        tabIndex="-1"
        :class="classNames.overlay"
        @click="role === 'alertdialog' ? undefined : close" />

      <component :is="dialogElement"
        :role="roleAttribute"
        :class="classNames.element"
        :aria-labelledby="titleId">
        <div role="document" :class="classNames.document">
          <span
            data-a11y-dialog-hide
            :aria-label="closeButtonLabel"
            @click="close"
            :class="classNames.closeButton">
            <slot name="closeButtonContent">
              {{ '\u00D7' }}
            </slot>
          </span>

          <div :id="fullTitleId" :class="classNames.title">
            <slot name="title" />
          </div>

          <slot />
        </div>
      </component>
    </div>
  </portal>
</template>

<script>
  import A11yDialog from 'a11y-dialog'
  import { Portal } from 'portal-vue'
  export default {
    name: 'VueA11yDialog',
    props: {
      id: { type: String, required: true },
      appRoot: { type: [String, Array], required: true },
      dialogRoot: { type: String, required: true },
      classNames: { type: Object, default: () => ({}) },
      titleId: { type: String },
      closeButtonLabel: { type: String, default: 'Close this dialog window' },
      disableNative: { type: Boolean, default: false },
      role: { type: String, default: 'dialog' }
    },
    components: {
      Portal
    },
    computed: {
      fullTitleId () {
        return this.titleId || this.id + '-title'
      },
      dialogElement () {
        return this.disableNative ? 'div' : 'dialog'
      },
      roleAttribute () {
        return ['dialog', 'alertdialog'].includes(this.role)
          ? this.role
          : 'dialog'
      },
      portalTarget () {
        return this.dialogRoot || this.appRoot
      }
    },
    data: () => ({
      dialog: null
    }),
    methods: {
      close () {
        this.dialog.hide()
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.dialog = new A11yDialog(this.$refs.rootElement, this.appRoot)
        this.$emit('dialog-ref', this.dialog)
      })
    },
    destroyed () {
      if (this.dialog) {
        this.dialog.destroy()
      }
      this.$emit('dialog-ref')
    }
  }
</script>
<style lang="scss">
.back-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  fill: #51a3f3;
  color: #51a3f3;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  p {
    margin-bottom: 0;
  }
}
.close-icon {
  float: right;
  width: 30px;
  height: 30px;
  cursor: pointer;
  fill: #55616E;
}
.primary-button {
    height: 40px;
    width: 110px;
}
#app-dialog dialog{
  z-index: 100;
  border: none;
  min-height: 282px;	
  width: 720px;	
  border-radius: 4px;	
  background-color: #FFFFFF;	
  box-shadow: 0 10px 40px 0 rgba(0,0,0,0.1);
  padding-bottom: 15px 
}
#main-title div.wrapper{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header {
    width: 220px;
    padding: 22px 0 19px 15px;	
    color: #212B36;	
    font-family: "Helvetica Neue";	
    font-size: 14px;	
    font-weight: 600;	
    line-height: 35px;
    div {
        height: 35px;
    }
  }
  .header-content {
    width: 500px;
    padding: 22px 0 19px 15px;	
    color: #212B36;	
    font-family: "Helvetica Neue";	
    font-size: 14px;	
    line-height: 35px;
    div {
      height: 35px;
    }
    .price {
      height: 25px;
      color: #55616E;	
      font-family: "Helvetica Neue";	
      font-size: 14px;	
      line-height: 25px;
    }
  }
}

.routing-header {
  color: #55616E;
  font-weight: 500;
  font-size: 18px;
}
.invoice-container {
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    .primary-button {
        height: 40px;
        width: 130px;
      }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 390px;
    background-color: #FFFFFF;
    padding-top: 15px;
    .container-title {
      height: 30px;	
      width: 432px;	
      color: #000000;		
      font-size: 18px;
      font-weight: 500;	
      line-height: 30px;
      padding: 5px 0 5px 15px;
      font-family: "Helvetica Neue";
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;
}
table thead tr {
  height: 37px;
  //background: #F8F9FE;
  text-align: left;
}
table, tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #F0F1FA;
  -webkit-box-shadow: inset 0 -1px 0 0 #F0F1FA;
  -moz-box-shadow: inset 0 -1px 0 0 #F0F1FA;
  background-color: #FFFFFF;
}
table, tr:last-child {
  box-shadow: inset 0 0 0 0 #F0F1FA;
  -webkit-box-shadow: inset 0 0 0 0 #F0F1FA;
  -moz-box-shadow: inset 0 0 0 0 #F0F1FA;
}
table tr th {
  padding: 13px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  float: right;
  width: 75px;
}
.Invoice_table_header th {
  height: 16px;
  color: #212B36;	
  font-weight: normal;
  font-family: 'Helvetica Neue';
  font-size: 14px;	
  font-weight: 600;	
  line-height: 16px;
  padding: 11px 0 10px 0;
}
tbody th {
  color: #212B36;	
  font-weight: normal;
  font-family: "Helvetica Neue";	
  height: 20px;
  font-size: 14px;	
  line-height: 20px;
  padding: 13px 10px;
  text-align: left;
}
table thead th:first-child {
    padding-left: 35px;
}
table th:first-child {
  padding-left: 35px;
}
tbody th.created_by {
  line-height: 20px;
  height: 30px;
  padding: 10px 0 10px 0; 
}
tbody th.break {
  max-width: 100px;
  word-wrap:break-word;
  padding-right: 20px;
}
tbody th.vendor {
  div {
    margin-bottom: 5px;
  }
  .secondary-button {
    height: 20px;	
    width: 60px;	
    border: 1px solid #BDBFD8;	
    border-radius: 4px;	
    background-color: #FFFFFF;
    padding: 0;
    color: #55616E;		
    font-size: 12px;	
    font-weight: 300;	
    line-height: 15px;	
    text-align: center;
    float: right;
  }
}
tbody th.icon {
  height: 30px;
  float: right;
  margin: 0 auto;
  padding-right: 20px;
  .svg-grey {
    fill: #55616E;
    height: 30px;
    width: 30px;
  }
}
.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
}
.running {
  background-color: #24e2b8;
}
.stop {
  background-color: #d2305b;
}
.hold {
  background-color: #ffc941;
}
th.status:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24E2B8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 30px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding: 13px 0 13px 12px;
  width: 200px;
}

tbody th.vendor {
  min-width: 180px;
}

tbody th.sell_rate {
  min-width: 100px;
}
</style>
